import clientWorkIsDone from "../../state/tasks";
import { api_configuration } from "../../../common";
import { updatePermissions } from "../../state 2 interface/permissions";
import { executeAction } from "../../state/actions";
import { executeCommand } from "../../state/commands";
import { uploadFilesInQueue } from "./fileUpload";
import { InstructionError } from "./InstructionError";
import client_read_api = api_configuration.types.client_state.alan_api;
import api_application = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;
import views_api = api_configuration.libraries.gui_definition_lib.types.views.alan_api;
import messages = require("../../front/messages");

export async function command(command: client_read_api.Cyes__started): Promise<void> {
	messages.removeAllMessages();
	await clientWorkIsDone();
	switch (command.properties.is_valid.state.name) {
		case "no": {
			messages.addMessage("warning", "Invalid parameters", { body: "Check all fields and try again." });
			throw new InstructionError();
		}
		case "yes": {
			await uploadFilesInQueue(command.properties.node);
			await executeCommand(command);
			const entity_node = command.parent.parent.parent.input.entity().output.node();
			updatePermissions(entity_node);
			break;
		}
		default:
			unexpectedState(command.properties.is_valid.state);
	}
}

export async function action(
	action: client_read_api.Cyes__started,
	view_bindings: Record<string, views_api.Cview_bindings>,
	can_use_containing_view: boolean,
	view_node_type: api_application.Cnode__application
): Promise<void> {
	await clientWorkIsDone();
	switch (action.properties.is_valid.state.name) {
		case "yes":
			await uploadFilesInQueue(action.properties.node);
			return executeAction(action, view_bindings, can_use_containing_view, view_node_type);
		case "no":
			messages.addMessage("warning", "Invalid parameters", { body: "Check all fields and try again." });
			throw new InstructionError();
		default:
			unexpectedState(action.properties.is_valid.state);
	}
}
